import { Discussion } from "../types/discussion";
import { DiscussionActions } from "../types/discussion-actions";
import { DiscussionCommentActions } from "../types/discussion-comment-actions";

export function discussions(
    state: { [id: string]: Discussion } = {},
    action: DiscussionActions | DiscussionCommentActions
): { [id: string]: Discussion } {
    switch (action.type) {
        case "discussions/fetch-success":
            return { ...state, ...action.data.entities.discussions };
        case "discussions/loadmore-success":
            if (action.data.result.length > 0)
                return {
                    ...state,
                    ...action.data.entities.discussions,
                };
            else {
                return {
                    ...state,
                };
            }
        case "discussions/create-success":
            return {
                ...state,
                [action.data.result]:
                    action.data.entities.discussions[action.data.result],
            };

        case "discussion-comments/create-success":
            const comment = action.data.entities.comments[action.data.result];
            const discussion = state[comment.discussion_id];

            return {
                ...state,
                [discussion.id]: {
                    ...discussion,
                    comments: [...discussion.comments, comment.id],
                },
            };

        case "discussion-comments/fetch-success":
            return {
                ...state,
                [action.discussionId]: {
                    ...state[action.discussionId],
                    comments: action.data.result,
                },
            };

        case "discussions/update-success":
            const discuss_id = action.discussion_id;
            const discussions =
                action.data.entities.discussions[action.discussion_id];
            return {
                ...state,
                [discuss_id]: {
                    ...state[discuss_id],
                    subject: discussions.subject,
                    description: discussions.description,
                    discussion_documents: discussions.discussion_documents,
                },
            };
        case "discussions/create-reactions":
            const discussionId = action.data.discussion_id as string;
            const reactions = action.data.emoji_type;
            return {
                ...state,
                [discussionId]: {
                    ...state[discussionId],
                    discussion_reaction: {
                        ...state[discussionId].discussion_reaction,
                        user_reacted_emojis: reactions ? [reactions] : [],
                        user_reacted: true,
                        reaction_counts:
                            state[discussionId].discussion_reaction
                                .reaction_counts + 1,
                        total_emoji_types: {
                            ...state[discussionId].discussion_reaction
                                .total_emoji_types,
                            [reactions as string]:
                                (state[discussionId].discussion_reaction
                                    .total_emoji_types[
                                    reactions as keyof (typeof state)[typeof discussionId]["discussion_reaction"]["total_emoji_types"]
                                ] || 0) + 1,
                        },
                    },
                },
            };

        case "discussions/remove-reactions":
            const DiscussionId = action.data.discussion_id as string;
            const prevActionType = action.actionType;
            return {
                ...state,
                [DiscussionId]: {
                    ...state[DiscussionId],
                    discussion_reaction: {
                        ...state[DiscussionId].discussion_reaction,
                        user_reacted_emojis: [],
                        user_reacted: false,
                        reaction_counts:
                            state[DiscussionId].discussion_reaction
                                .reaction_counts - 1,
                        total_emoji_types: {
                            ...state[DiscussionId].discussion_reaction
                                .total_emoji_types,
                            [prevActionType as string]:
                                (state[DiscussionId].discussion_reaction
                                    .total_emoji_types[
                                    prevActionType as keyof (typeof state)[typeof DiscussionId]["discussion_reaction"]["total_emoji_types"]
                                ] || 0) - 1,
                        },
                    },
                },
            };

        case "discussions/update-reactions":
            const disc_Id = action.data.discussion_id as string;
            const updatedReactions = action.data["emoji_type"];
            return {
                ...state,
                [disc_Id]: {
                    ...state[disc_Id],
                    discussion_reaction: {
                        ...state[disc_Id]["discussion_reaction"],
                        reaction_counts:
                            state[disc_Id]["discussion_reaction"]
                                .reaction_counts,
                        user_reacted: true,
                        user_reacted_emojis: updatedReactions
                            ? [updatedReactions]
                            : [],
                        total_emoji_types: {
                            ...state[disc_Id].discussion_reaction
                                .total_emoji_types,
                            [action.actionType as string]:
                                (state[disc_Id].discussion_reaction
                                    .total_emoji_types[
                                    action.actionType as keyof (typeof state)[typeof disc_Id]["discussion_reaction"]["total_emoji_types"]
                                ] || 0) - 1,
                            [updatedReactions as string]:
                                (state[disc_Id].discussion_reaction
                                    .total_emoji_types[
                                    updatedReactions as keyof (typeof state)[typeof disc_Id]["discussion_reaction"]["total_emoji_types"]
                                ] || 0) + 1,
                        },
                    },
                },
            };
        default:
            return state;
    }
}
